import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=368b80fc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368b80fc')) {
      api.createRecord('368b80fc', component.options)
    } else {
      api.reload('368b80fc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=368b80fc&", function () {
      api.rerender('368b80fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LVFjjehlJMy0/JS/offershelp.vue"
export default component.exports